import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineAngleUpBIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11.2001 8.4502 5.6001 14.1501c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l5-4.9 5 4.9c.4.4 1 .4 1.4 0 .2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7l-5.6-5.6999c-.5-.4-1.1-.4-1.6 0 .1 0 .1 0 0 0Z"/>
  </SvgIcon>
}

export default LineAngleUpBIcon
